import axios from 'axios';
import {
  SET_LOADER,
  SET_LOADER_SECONDARY,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  GET_MENU_SETUP_CATEGORY_ALL,
  GET_CUSTOM_MENU_LIST,
} from '../../types';

import Alert from 'react-s-alert';

import { setErrors } from '../../actions/errorActions';
import { serverApi } from '../../../config/Keys';

/***************************************
 * @DESC - ADD CATEGORY MENU SETUP ACTION
 *****************************************/
export const get_all_subcategoryIn_menuSetup =
  (categoryId) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let data = await axios.get(
        `${serverApi}/subcategory?category_id=${categoryId}`
      );
      if (data.status === 200) {
        dispatch({
          type: GET_MENU_SETUP_CATEGORY_ALL,
          payload: data.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_list_of_custom_menu_data = (restId) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER_SECONDARY });
  try {
    let data = await axios.get(`${serverApi}/menu?restaurant=${restId}`);
    if (data.status === 200) {
      dispatch({
        type: GET_CUSTOM_MENU_LIST,
        payload: data.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const add_category_menu_setup =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_category_menu_setup = await axios.post(
        `${serverApi}/menu-category`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (add_category_menu_setup.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Category Added Successfully</h4>`, {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const create_custom_menu =
  (formData, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let create_custom_menu = await axios.post(`${serverApi}/menu`, formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      });
      if (create_custom_menu.status === 201) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>menu created Successfully</h4>`, {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const edit_category_menu_setup =
  (categoryId, formData, token, onSuccess, msg) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let edit_category_menu_setup = await axios.patch(
        `${serverApi}/menu-category/${categoryId}`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (edit_category_menu_setup.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>${msg}</h4>`, {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess(categoryId);
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const delete_category_menu_setup =
  (categoryId, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let edit_category_menu_setup = await axios.delete(
        `${serverApi}/menu-category/${categoryId}`,

        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (edit_category_menu_setup.status === 200) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success(`<h4>Category deleted  Successfully</h4>`, {
          position: 'top-right',
          effect: 'bouncyflip',
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const update_ordering_subscription_taxes =
  (formData, token, categoryValue, categoryId, onSuccess, onError) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let update_ordering_subscription_taxes = await axios.post(
        `${serverApi}/vendor/menu-category${
          categoryValue ? `?categoryId=${categoryId}` : ''
        }`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      if (update_ordering_subscription_taxes.status === 200) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onError(err);
    }
  };
